import { render } from "./attendance-admin.vue?vue&type=template&id=4fa905d3"
import script from "./attendance-admin.vue?vue&type=script&lang=js"
export * from "./attendance-admin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__